import { JobseekerRegistrationService } from '../../services/registration/jobseeker-registration.service';
import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-resume-skills',
  templateUrl: './add-resume-skills.component.html',
  styleUrls: ['./add-resume-skills.component.scss'],
  providers: [JobseekerRegistrationService]
})
export class AddResumeSkillsComponent implements OnInit {

  addNewSkillForm: UntypedFormGroup;
  skillCategoryList = [];
  subLoader = false;
  clicked = false;
  skillAddedCheck = 0;
  constructor(private matDialogRef: MatDialogRef<AddResumeSkillsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetector: ChangeDetectorRef,
    private resumeSvc: JobseekerRegistrationService,
    private notification_srv: NotificationService) {

  }
  ngOnInit() {


    this.addNewSkillForm = new UntypedFormGroup({
      skillCatCode: new UntypedFormControl(null, [Validators.required]),
      skillCode: new UntypedFormControl(0),
      title: new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
      status: new UntypedFormControl(1),
      altKeywords: new UntypedFormControl('')
    })

    if (this.data && this.data.skillCategoryList) {
      this.skillCategoryList = this.data.skillCategoryList;
    }


  }

  ngAfterViewInit() {
    this.changeDetector.detectChanges();
  }

  openLink(event: MouseEvent): void {
    // this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  getResumeDetailsWithMaster() {
    this.subLoader = true;
    this.resumeSvc.getResumeDetailsWithMaster({
      sellerShortCode: environment.SHORTCODE
    }).subscribe(res => {

      if (res && res['status']) {
        if (res['data']) {
          this.skillCategoryList = res['data'].skillCategoryList;
        }
        this.subLoader = false;
      } else {
        this.subLoader = false;
      }
    })
  }

  saveSkill() {
    if (this.addNewSkillForm && this.addNewSkillForm.invalid) {
      this.markFormGroupTouched(this.addNewSkillForm);
      return;
    }
    this.clicked = true;
    this.resumeSvc.addNewSkill(this.addNewSkillForm.value).subscribe(res => {

      if (res && res['status']) {
        this.notification_srv.success(res['message'], 'Close', 8000);
        this.addNewSkillForm.reset();
        this.clicked = false;
        this.skillAddedCheck = 1;
      } else {
        this.notification_srv.error(res['message'], 'Close', 8000);
        this.clicked = false;

      }
    })

  }
  closeDialog() {
    this.matDialogRef.close(this.skillAddedCheck);
  }
  markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.markAsDirty();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
